module.exports = __webpack_public_path__ + "img/mic_icon.01368874.svg";